<template>
  <div>
    <div id="player-con"></div>
  </div>
</template>
<script>
export default {
  name: 'Video',
  props: {
    videoUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      player: null
    }
  },
  watch: {
    videoUrl(val, oldVal) {
      if (this.player) {
        this.player.dispose()
      }
      this.onVideo(val)
    }
  },
  mounted() {
    this.onVideo(this.videoUrl)
  },
  methods: {
    onVideo(url) {
      if (url) {
        // 移动端
        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
          this.player = window.Aliplayer(
            {
              id: 'player-con',
              source: url,
              width: '100%',
              height: '300px',
              autoplay: true,
              isLive: false,
              rePlay: false,
              playsinline: true,
              preload: true,
              controlBarVisibility: 'hover',
              useH5Prism: true
            },
            function(player) {
              console.log('The player is created')
            }
          )
        } else {
          // pc端
          this.player = window.Aliplayer(
            {
              id: 'player-con',
              source: url,
              width: '100%',
              height: '300px',
              autoplay: true,
              isLive: false,
              rePlay: false,
              playsinline: true,
              preload: true,
              controlBarVisibility: 'hover',
              useH5Prism: true,
              skinLayout: [
                {
                  name: 'bigPlayButton',
                  align: 'blabs',
                  x: 30,
                  y: 80
                },
                {
                  name: 'H5Loading',
                  align: 'cc'
                },
                {
                  name: 'errorDisplay',
                  align: 'tlabs',
                  x: 0,
                  y: 0
                },
                {
                  name: 'infoDisplay'
                },
                {
                  name: 'tooltip',
                  align: 'blabs',
                  x: 0,
                  y: 56
                },
                {
                  name: 'thumbnail'
                },
                {
                  name: 'controlBar',
                  align: 'blabs',
                  x: 0,
                  y: 0,
                  children: [
                    {
                      name: 'progress',
                      align: 'blabs',
                      x: 0,
                      y: 44
                    },
                    {
                      name: 'playButton',
                      align: 'tl',
                      x: 15,
                      y: 12
                    },
                    {
                      name: 'timeDisplay',
                      align: 'tl',
                      x: 10,
                      y: 7
                    },
                    {
                      name: 'subtitle',
                      align: 'tr',
                      x: 15,
                      y: 12
                    },
                    {
                      name: 'setting',
                      align: 'tr',
                      x: 15,
                      y: 12
                    },
                    {
                      name: 'volume',
                      align: 'tr',
                      x: 5,
                      y: 10
                    }
                  ]
                }
              ]
            },
            function(player) {
              console.log('The player is created')
            }
          )
        }
      } else {
        this.player = null
      }
    }
  }
}
</script>
